var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineThroughPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9727 12.584L1.78906 0.726562C1.61133 0.574219 1.35742 0.625 1.20508 0.777344L0.951172 1.10742C0.824219 1.28516 0.849609 1.53906 1.02734 1.66602L16.2109 13.5488C16.3633 13.6758 16.6426 13.6504 16.7695 13.4727L17.0234 13.168C17.1758 12.9902 17.125 12.7363 16.9727 12.584ZM9 1.84375C10.3203 1.84375 11.4375 2.96094 11.4375 4.28125C11.4375 5.01758 11.1074 5.65234 10.625 6.08398L11.5898 6.8457C12.25 6.18555 12.6562 5.29688 12.6562 4.28125C12.6562 2.27539 11.0059 0.625 9 0.625C7.67969 0.625 6.53711 1.33594 5.87695 2.37695L6.8418 3.13867C7.27344 2.37695 8.06055 1.84375 9 1.84375ZM4.53125 12.4062V11.7715C4.53125 10.5527 5.49609 9.5625 6.71484 9.5625C6.81641 9.5625 6.94336 9.61328 7.12109 9.66406C7.73047 9.86719 8.36523 9.96875 9 9.96875C9.20312 9.96875 9.38086 9.94336 9.58398 9.91797L7.9082 8.62305C7.78125 8.57227 7.6543 8.54688 7.52734 8.52148C7.27344 8.41992 6.99414 8.36914 6.71484 8.36914C4.83594 8.34375 3.3125 9.89258 3.3125 11.7715V12.4062C3.3125 13.0918 3.8457 13.625 4.53125 13.625H13.4688C13.6973 13.625 13.9004 13.5742 14.1035 13.4473L12.7832 12.4062H4.53125Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineThroughPerson);
export default __webpack_public_path__ + "static/media/line-through-person.9413c517.svg";
export { ForwardRef as ReactComponent };